<template>
  <div
    ref="scrollContainer"
    class="horizontal-scroll"
    @mousedown="onMouseDown"
    @mousemove="onMouseMove"
    @mouseup="onMouseUp"
    @mouseleave="onMouseUp"
    @wheel.prevent
  >
    <div
      v-for="(img, i) in images"
      :key="i"
      class="image-item"
      @click="onClickImage"
    >
      <el-image
        :src="img"
        fit="contain"
        class="image-itemwq"
        :preview-src-list="images"
        :preview-src-index="i"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalImageScroll',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      hasDragged: false
    }
  },
  methods: {
    onMouseDown(e) {
      this.isDragging = true
      this.hasDragged = false
      this.startX = e.pageX
      this.scrollLeft = this.$refs.scrollContainer.scrollLeft
      this.$refs.scrollContainer.classList.add('dragging')
    },
    onMouseMove(e) {
      if (!this.isDragging) return

      const dx = e.pageX - this.startX
      if (Math.abs(dx) > 5) {
        this.hasDragged = true
      }

      if (this.hasDragged) {
        e.preventDefault()
        this.$refs.scrollContainer.scrollLeft = this.scrollLeft - dx
      }
    },
    onMouseUp() {
      if (this.isDragging) {
        this.isDragging = false
        this.$refs.scrollContainer.classList.remove('dragging')
      }
    },
    onClickImage(e) {
      if (this.hasDragged) {
        e.preventDefault()
        e.stopPropagation()
      }
    }
  }
}
</script>

<style scoped>
.horizontal-scroll {
  width: 100%;
  white-space: nowrap;
  overflow: hidden; /* 关闭浏览器原生滚动，禁止惯性 */
  user-select: none;
  cursor: grab;
  padding: 10px 0;
}

.horizontal-scroll.dragging {
  cursor: grabbing;
}

.image-item {
  display: inline-block;
  margin-right: 10px;
}

.image-itemwq {
  display: block;
  height: 240px;
  border-radius: 8px;
  object-fit: cover;
  pointer-events: auto;
  width: 100%;
  margin-right: 20px;
}
</style>
